import { render } from "./404post.vue?vue&type=template&id=ce12e132&scoped=true"
import script from "./404post.vue?vue&type=script&lang=js"
export * from "./404post.vue?vue&type=script&lang=js"

import "./404post.vue?vue&type=style&index=0&id=ce12e132&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ce12e132"

export default script